import styles from './AssistedMode.module.css';

import React, { useState } from 'react';

import useTranslation from 'components/hooks/useTranslation';
import DatabaseERModel from 'components/ui/common/DatabaseERModel';
import Icon from 'components/ui/common/Icon';

export default function AssistedMode({ nodes, edges, formikProps, height }) {
  const { t } = useTranslation();

  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const hasNodes = nodes.length > 0;

  return (
    <div
      className={styles.boardContainer}
      style={{ height: `${height}px` }}
      onDragEnter={() => setIsDraggingOver(true)}
      onDragLeave={() => setIsDraggingOver(false)}
      onDrop={() => setIsDraggingOver(false)}
    >
      <div className={styles.canvas}>
        <DatabaseERModel
          initialNodes={nodes}
          initialEdges={edges}
          formikProps={formikProps}
        />
      </div>

      {!hasNodes && (
        <div className={styles.emptyState}>
          <div className={`${styles.dragMessageWrapper} ${isDraggingOver ? styles.draggingHover : ''}`}>
            <Icon icon={'ads_click'} />
            {t('drag.table.here')}
          </div>
        </div>
      )}
    </div>
  );
}
